module.exports = __webpack_public_path__ + "img/payment-method-gpo.b966d646.png";